export const GROUP_PUBLICATION_PRIVACY_OPTIONS = [
  { text: 'Public', value: 'Public' },
  { text: 'Private', value: 'Private' },
];
